import { Reveal } from "@/components/reveal";
import "./styles.scss";

const METRICS = [
  { value: "+[N]", label: "provedores usam a Provenduz" },
  { value: "[N]", label: "apps publicados nas lojas" },
  { value: "até 40%", label: "menos chamados de 2ª via" },
  { value: "R$ [N]", label: "em pagamentos pelo app / mês" },
];

export const IspTrust = () => {
  return (
    <section className="isp-trust">
      <Reveal className="isp-trust__panel">
        <div className="isp-trust__metrics">
          {METRICS.map((m) => (
            <div key={m.label} className="isp-trust__metric">
              <span className="isp-trust__value">{m.value}</span>
              <span className="isp-trust__label">{m.label}</span>
            </div>
          ))}
        </div>
        <div className="isp-trust__logos">
          {Array.from({ length: 5 }).map((_, i) => (
            <span key={i}>[ LOGO CLIENTE ]</span>
          ))}
        </div>
      </Reveal>
    </section>
  );
};
